/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShadow = createReactComponent("shadow", "IconShadow", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M13 12h5", key: "svg-1" }],
  ["path", { d: "M13 15h4", key: "svg-2" }],
  ["path", { d: "M13 18h1", key: "svg-3" }],
  ["path", { d: "M13 9h4", key: "svg-4" }],
  ["path", { d: "M13 6h1", key: "svg-5" }]
]);

export { IconShadow as default };
//# sourceMappingURL=IconShadow.js.map
